import React, { useState } from 'react';
import {Field, Formik } from 'formik';
import no_profile from "../images/no_profile.png";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const StepOne = ({step, nextStep, prevStep, handleFormData, values }) => {

	const [profile_url, setProfileUrl] = useState(null);
	const [profile_file, setProfileFile] = useState(null);
	const [mobile_no1, setMobileNo1] = useState(null);
	const [mobile_no2, setMobileNo2] = useState(null);

	const convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
		  const fileReader = new FileReader();
		  fileReader.readAsDataURL(file)
		  fileReader.onload = () => {
			resolve(fileReader.result);
		  }
		  fileReader.onerror = (error) => {
			reject(error);
		  }
		})
	  }

	const handleFileRead = async (event) => {
		const file = event.currentTarget.files[0];
		const base64 = await convertBase64(file);
		setProfileUrl(base64); 
		setProfileFile(base64);
	  }

    return (
		
        <div>
            <div className="border-b-2 py-4">
					<div className="uppercase tracking-wide text-xs font-bold text-gray-500 mb-1 leading-tight">{`Step: ${step} of 6`}</div>
					<div className="flex flex-col md:flex-row md:items-center md:justify-between">
						<div className="flex-1">
							<div>
								<div className="text-md font-bold text-gray-800 leading-tight">Personal Information</div>
							</div>
						</div>

						<div className="flex items-center ml-4 md:w-64">
							<div className="w-full bg-white rounded-full mr-2">
								<div className="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white" style={{ width: '20%' }}></div>
							</div>
							<div className="text-xs w-10 text-gray-600">20%</div>
						</div>
					</div>
            </div>

			<Formik
			initialValues={{ 
				post_applied: '',
				dateofavailability: '',
				indosno: '',
				name: '',
				email: '',
				telephone: '',
				dateofbirth: '',
				nationality: '',
				permanent_address: '',
				present_address: '',
				qualification: '',
				pre_sea_training: '',
				marital_status: '',
				no_children_age: '',
				next_of_kin_name: '',
				relationship: '',
				saftey_gear: ''
			}}
			validate={values => {

				console.log(values)
		
			const errors = {};

			if (!values.email) {
			errors.email = 'This is a required field';
			} else if (
			!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
			) {
			errors.email = 'Invalid email address';
			}

		if(!values.nationality)
		{
			errors.nationality = 'This is a required field';
		}

		if(!values.dateofavailability) {
			errors.dateofavailability = 'This is a required field';
		}

		if(!values.indosno) {
			errors.indosno = 'This is a required field';
		}

		if(!values.post_applied)
		{
			errors.post_applied = 'This is a required field';
		}
		
		if(!values.name) {
			errors.name = 'This is a required field';
		}
		
		if(!values.dateofbirth) {
			errors.dateofbirth = 'This is a required field';
		}

		if(!values.dateofavailability) {
			errors.dateofavailability = 'This is a required field';
		}

		if(!values.indosno) {
			errors.indosno = 'This is a required field';
		}
		
		if(!values.permanent_address){
			errors.permanent_address = 'This is a required field';
		}
		
		if(!values.present_address){
			errors.present_address = 'This is a required field';
		}

		if(!values.qualification){
			errors.qualification = 'This is a required field';
		}
		
		return errors;
	}}
	onSubmit={(values, { setSubmitting, resetForm }) => {
		try{
		const formData  = new FormData();
		if(values)
		{
		Object.keys(values).map((item, i) => {
			formData.append(item, values[item]);
		});
		}
		console.log(values, 'formData')
		//formData.append('profile_file', profile_file);
		handleFormData({ ...values, profile_file: profile_file, mobile_one: mobile_no1, mobile_two: mobile_no2 });
		setSubmitting(false);
		nextStep();
		}catch(e){ 
			console.log(e)
		}
	}}
	>
	{({
		values,
		errors,
		touched,
		handleChange,
		handleBlur,
		handleSubmit,
		setFieldValue,
		isSubmitting,
		/* and other goodies */
	}) => (
	<form onSubmit={handleSubmit}>
            <div className="py-10">	
					<div>
						<div className="mb-5 text-center">
							<div className="mx-auto w-32 h-32 mb-2 border rounded-full relative bg-gray-100 mb-4 shadow-inset">
								<img id="image" src={profile_url ?? no_profile} className="object-cover w-full h-32 rounded-full" />
							</div>
							
							<label 
								for="fileInput"
								type="button"
								className="cursor-pointer inine-flex justify-between items-center focus:outline-none border py-1 text-sm px-4 rounded-md shadow-sm border border-gray-500 text-left text-gray-600 bg-white hover:bg-gray-100 font-medium text-gray-800"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="inline-flex flex-shrink-0 w-6 h-6 -mt-1 mr-1" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
									<rect x="0" y="0" width="24" height="24" stroke="none"></rect>
									<path d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
									<circle cx="12" cy="13" r="3" />
								</svg>						
								Browse Photo
							</label>

							<div className="mx-auto w-48 text-gray-500 text-xs text-center mt-1">Click to add profile picture</div>

							<input name="profile" onChange={(event) => { handleFileRead(event);  }} id="fileInput" accept="image/*" className="hidden" type="file" />
						</div>

						<div className="mb-5">
							<label for="post_applied" className="font-bold mb-1 text-sm text-gray-800 block">Post Applied For <span className="text-orange-500">*</span></label>
							<select placeholder='Select' name='post_applied' id="post_applied" onChange={handleChange} className={`w-full px-4 py-2 rounded-md border ${errors.post_applied && touched.post_applied && errors.post_applied ? 'border-red-500' : 'border-gray-500'}  shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}>
								<option value="">Select...</option>
								<option value="Master">Master</option>
								<option value="Chief Officer">Chief Officer</option>
								<option value="Second Officer">Second Officer</option>
								<option value="Third Officer">Third Officer</option>
								<option value="Jr. Officer">Jr. Officer</option>
								<option value="Chief Engineer">Chief Engineer</option>
								<option value="Second Engineer">Second Engineer</option>
								<option value="Third Engineer">Third Engineer</option>
								<option value="Fourth Engineer">Fourth Engineer</option>
								<option value="Electrical Officer">Electrical Officer</option>
								<option value="Jr. Engineer">Jr.Engineer</option>
								<option value="Able Seaman">Able Seaman</option>
								<option value="Oiler">Oiler</option>
								<option value="Deck Fitter">Deck Fitter</option>
								<option value="Engine Fitter">Engine Fitter</option>
								<option value="Wiper">Wiper</option>
								<option value="OS">OS</option>
								<option value="GS">GS</option>
								<option value="BOSUN">BOSUN</option>
								<option value="Cook">Cook</option>
								<option value="Deck Cadet">Deck Cadet</option>
							</select>
							<span class="text-sm text-red-600">{errors.post_applied && touched.post_applied && errors.post_applied}</span>
                        </div>

						<div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="dateofavailability" className="font-bold mb-1 text-sm text-gray-800 block">Date Of Availability <span className="text-orange-500">*</span></label>
									<input type="date" name='dateofavailability' id='dateofavailability'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.dateofavailability}
										className={`w-full px-4 py-2 rounded-md border ${errors.dateofavailability && touched.dateofavailability && errors.dateofavailability ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your date of birth..."/>
										<span class="text-sm text-red-600">{errors.dateofavailability && touched.dateofavailability && errors.dateofavailability}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="indosno" className="font-bold mb-1 text-sm text-gray-800 block">INDOS No. <span className="text-orange-500">*</span></label>
									<input type="text" name='indosno' id='indosno'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.indosno}
										className={`w-full px-4 py-2 rounded-md border ${errors.indosno && touched.indosno && errors.indosno ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter INDOS Number..."/>
										<span class="text-sm text-red-600">{errors.indosno && touched.indosno && errors.indosno}</span>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<label for="name" className="font-bold mb-1 text-sm text-gray-800 block">Name (In Block Latter)<span className="text-orange-500">*</span></label>
							<input type="text" name='name' id='name'
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.name}
								className={`w-full px-4 py-2 rounded-md border ${errors.name && touched.name && errors.name ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
								placeholder="Enter your name"/>
								<span class="text-sm text-red-600">{errors.name && touched.name && errors.name}</span>
						</div>

						<div className="flex gap-4">
						<div className="w-1/2">
							<div className="mb-5">
								<label for="email" className="font-bold mb-1 text-sm text-gray-800 block">Email <span className="text-orange-500">*</span></label>
								<input type="email" name='email' id='email'
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.email}
									className={`w-full px-4 py-2 rounded-md border ${errors.email && touched.email && errors.email ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
									placeholder="Enter your email address..."/>
									<span class="text-sm text-red-600">{errors.email && touched.email && errors.email}</span>
							</div>
						</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="mobile_no1" className="font-bold mb-1 text-sm text-gray-800 block">Mobile No. <span className="text-orange-500">*</span></label>
									<PhoneInput
									country={'in'}
									containerStyle={{ width: '100%' }}
									inputStyle={{ width: '100%', border: "1px solid gray" }}
									buttonStyle={{ border: "1px solid gray" }}
									searchStyle={{ width: '100%', margin: 0 }}
									enableSearch={true}
									disableSearchIcon={true}
									inputProps={{
										name: 'mobile_no1',
										required: true,
										autoFocus: false
									  }} 
									value={values.telephone}
									onChange={(mob1) => setMobileNo1(mob1)}
									/>
									<span class="text-sm text-red-600">{errors.telephone && touched.telephone && errors.telephone}</span>
									{/* <input type="number" name='telephone' id='telephone'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.telephone}
										className={`w-full px-4 py-2 rounded-md border ${errors.telephone && touched.telephone && errors.telephone ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your telephone..."/>
										 */}
								</div>
							</div>
						</div>

						<div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="dateofbirth" className="font-bold mb-1 text-sm text-gray-800 block">Date Of Birth <span className="text-orange-500">*</span></label>
									<input type="date" name='dateofbirth' id='dateofbirth'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.dateofbirth}
										className={`w-full px-4 py-2 rounded-md border ${errors.dateofbirth && touched.dateofbirth && errors.dateofbirth ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your date of birth..."/>
										<span class="text-sm text-red-600">{errors.dateofbirth && touched.dateofbirth && errors.dateofbirth}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="nationality" className="font-bold mb-1 text-sm text-gray-800 block">Nationality <span className="text-orange-500">*</span></label>
									<input type="text" name='nationality' id='nationality'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.nationality}
										className={`w-full px-4 py-2 rounded-md border ${errors.nationality && touched.nationality && errors.nationality ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your nationality..."/>
										<span class="text-sm text-red-600">{errors.nationality && touched.nationality && errors.nationality}</span>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<label for="permanent_address" className="font-bold mb-1 text-sm text-gray-800 block">Permanent Address <span className="text-orange-500">*</span></label>
							<textarea
								className={`w-full px-4 py-2 rounded-md border ${errors.permanent_address && touched.permanent_address && errors.permanent_address ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
								name="permanent_address"
								id='permanent_address'
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.permanent_address}
								placeholder="Enter your Permanent address..."></textarea>
								<span class="text-sm text-red-600">{errors.permanent_address && touched.permanent_address && errors.permanent_address}</span>
						</div>

						<div className="mb-5">
							<label for="present_address" className="font-bold mb-1 text-sm text-gray-800 block">Present Address <span className="text-orange-500">*</span></label>
							<textarea
								className={`w-full px-4 py-2 rounded-md border ${errors.present_address && touched.present_address && errors.present_address ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
								name="present_address"
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.present_address}
								placeholder="Enter your Present address..."></textarea>
								<span class="text-sm text-red-600">{errors.present_address && touched.present_address && errors.present_address}</span>
						</div>

						<div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="qualification" className="font-bold mb-1 text-sm text-gray-800 block">Qualification <span className="text-orange-500">*</span></label>
									<input type="text" name='qualification' id='qualification'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.qualification}
										className={`w-full px-4 py-2 rounded-md border ${errors.qualification && touched.qualification && errors.qualification ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your qualification..."/>
										<span class="text-sm text-red-600">{errors.qualification && touched.qualification && errors.qualification}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="pre_sea_training" className="font-bold mb-1 text-sm text-gray-800 block">Pre Sea Training </label>
									<input type="text"
										name='pre_sea_training'
										id='pre_sea_training'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.pre_sea_training}
										className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
										placeholder="Enter your pre sea training..."/>
								</div>
							</div>
						</div>

						<div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="marital_status" className="font-bold mb-1 text-sm text-gray-800 block">Marital Status</label>
									<input type="text"
										name='marital_status'
										id='marital_status'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.marital_status}
										className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
										placeholder="Enter your marital status..."/>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="children_age" className="font-bold mb-1 text-sm text-gray-800 block">No. of Children / Age </label>
									<input type="text"
										name='no_children_age'
										id='no_children_age'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.no_children_age}
										className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
										placeholder="Enter your No. of children / Age..."/>
								</div>
							</div>
						</div>

						<div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="next_of_kin_name" className="font-bold mb-1 text-sm text-gray-800 block">Next of kin Name</label>
									<input type="text"
										name='next_of_kin_name'
										id='next_of_kin_name'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.next_of_kin_name}
										className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
										placeholder="Enter your next of kin name..."/>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="children_age" className="font-bold mb-1 text-sm text-gray-800 block">Relationship </label>
									<input type="text"
										name='relationship'
										id='relationship'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.relationship}
										className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
										placeholder="Enter your relationship..."/>
								</div>
							</div>
						</div>

						<div className="flex gap-4">
						<div className="w-1/2">
							<div className="mb-5">
								<label for="safety_gear_size" className="font-bold mb-1 text-sm text-gray-800 block">Safety Gear Size (Boiler Suit/ Safety Shoes)</label>
								<input type="text"
									name='saftey_gear'
									id='saftey_gear'
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.saftey_gear}
									className="w-full px-4 py-2 rounded-md shadow- border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
									placeholder="Enter your safety gear size..."/>
							</div>
						</div>
						<div className="w-1/2">
								<div className="mb-5">
									<label for="mobile_no2" className="font-bold mb-1 text-sm text-gray-800 block">Mobile No. </label>
									<PhoneInput
									country={'in'}
									containerStyle={{ width: '100%' }}
									inputStyle={{ width: '100%', border: "1px solid gray" }}
									buttonStyle={{ border: "1px solid gray" }}
									searchStyle={{ width: '100%', margin: 0 }}
									enableSearch={true}
									disableSearchIcon={true}
									inputProps={{
										name: 'mobile_no2',
										required: true,
										autoFocus: false
									  }} 
									value={values.telephone}
									onChange={(mob2) => setMobileNo2(mob2)}
									/>
									<span class="text-sm text-red-600">{errors.telephone && touched.telephone && errors.telephone}</span>
								</div>
							</div>
						</div>
					</div>
                </div>
	
		<div className=" bottom-0 left-0 right-0 py-5">
			<div className="max-w-3xl mx-auto px-4">
				<div className="flex justify-between">

					<div className="w-full text-right">
						<button
							type="submit"
							disabled={isSubmitting}
							className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-md shadow-sm text-center text-white bg-orange-500 hover:bg-orange-600 font-medium text-sm" 
						>Next</button>
					</div>
				</div>
			</div>
        </div>
	</form>)}
	</Formik>
    </div>        
    )
}

export default StepOne;